import api from './client';

export const adminUserAPI = {
  getAll: async () => {
    const response = await api.get('/api/admin/users');
    return response.data;
  },

  create: async (data: { username: string; password: string; email?: string }) => {
    const response = await api.post('/api/admin/users', data);
    return response.data;
  },

  update: async (id: number, data: { password?: string; email?: string }) => {
    const response = await api.put(`/api/admin/users/${id}`, data);
    return response.data;
  },

  delete: async (id: number) => {
    const response = await api.delete(`/api/admin/users/${id}`);
    return response.data;
  },
};
